<template>
  <div class="content-430">
    <div class="header-wrapper-430">
      <div class="class-search-box" style="margin-bottom: 8px">
        <Form
          ref="searchForm"
          label-position="right"
          :label-width="0"
          class="search-list-430 search-wrapper-430"
          inline
        >
          <FormItem class="sch-form-item" prop="areaCode" label="">
            <RemoteSelect
              v-model="formValidate.areaCode"
              placeholder="请选择地区"
              :remote-method="getAreaCodeList"
              :loading="loadingArea"
              :clearable="false"
              @change="handleAreaSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="item in areacodeList"
                :key="item.areaCode"
                :label="item.areaName"
                :value="item.areaCode"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem
            v-if="portOrg == 0"
            class="sch-form-item"
            prop="areaCode"
            label=""
          >
            <FormItem class="sch-form-item" prop="schoolIdShow" label="">
              <RemoteSelect
                v-model="formValidate.schoolIdShow"
                :placeholder="
                  formValidate.areaCode ? '请选择学校' : '请先选择地区'
                "
                :remote-method="getSchoolListForAreacode"
                :loading="loadingSchool"
                :disabled="!formValidate.areaCode"
                @clear="getSchoolListForAreacode('')"
                @change="handleSchoolSelect"
                @visible-change="loadAllList"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.orgId"
                  :label="item.name"
                  :value="item.orgId"
                >
                </el-option>
              </RemoteSelect>
            </FormItem>
          </FormItem>
          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选中学期`"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
              @on-init="onCascaderYTInit"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem prop="classData" label="">
            <Cascader
              v-model="formValidate.classData"
              :data="gradeAndClassList"
              trigger="hover"
              placeholder="请选择年级班级"
              class="mr-2"
              @on-visible-change="handleGradeSelect"
            ></Cascader>
          </FormItem>
          <FormItem prop="studentName" label="">
            <Input
              v-model="formValidate.studentName"
              clearable
              placeholder="请输入学生姓名"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="classroomName" label="">
            <Input
              v-model="formValidate.classroomName"
              clearable
              placeholder="请输入课程商品名称"
              class="search-input-430"
            ></Input>
          </FormItem>
          <Button
            class="search-430"
            type="primary"
            @click="handleSearch"
          >查询</Button>
          <Button class="search-430" @click="handleReset">重置</Button>
        </Form>
      </div>
      <div class="flex justify-content_end" style="margin-bottom: 8px">
        <Button type="primary" @click="handleExport">下载</Button>
      </div>
    </div>
    <div class="table-main">
      <Table
        :columns="tableColumns"
        :max-height="tableHeight"
        :data="tableData"
        :loading="tableLoading"
        border
      >
        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>
        <template slot="classroomName" slot-scope="{ row }">
          <TablePoptip :content="row.classroomName"> </TablePoptip>
        </template>
        <template slot="orgName" slot-scope="{ row }">
          <TablePoptip :content="row.orgName"> </TablePoptip>
        </template>
        <template slot="classroomFee" slot-scope="{ row }">
          <span>{{ row.classroomFee | initClassroomFee }}</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <span
            class="click-btn-430"
            @click="handleToOpenModal(row)"
          >入班</span>
          <span
            class="click-btn-430"
            style="color: #f56c6c"
            @click="handleApplyRefund(row)"
          >申请退款</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :total="pageInfo.total"
        show-sizer
        show-elevator
        show-total
        :current="pageInfo.pageNum"
        :page-size-opts="pageSizeOpts"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <Modal
      v-model="modalShow"
      :width="700"
      title="入班操作"
      :footer-hide="true"
    >
      <Alert type="warning">
        <p>
          确认将学生入班当前课班吗？入班后，未入班的课时将自动加入到当前所在的班级。
        </p>
        <p>
          ①如需加入其他班级，请通过：<span
            style="font-weight: bold; color: rgb(212, 0, 37)"
          >【先当前班级离班】→【后入到其他班级】，</span>完成操作！
        </p>
        <p>
          ②如学生未实际上课，请可通过<span style="font-weight: bold">【申请退款】</span>，操作学生退款。
        </p>
      </Alert>
      <div class="form-block">
        <div class="form-line">
          <div class="line-left">学生姓名：</div>
          <div class="line-right">{{ selectRow.studentName }}</div>
        </div>
        <div class="form-line">
          <div class="line-left">当前所在班级：</div>
          <div class="line-right">{{ selectRow.inClassClassroomName }}</div>
        </div>
        <div class="form-line">
          <div class="line-left">请选择入班节次：</div>
          <div class="line-normal">
            <Select
              v-model="selectClassValue"
              style="width: 400px"
              @on-change="changeValue"
            >
              <Option
                v-for="(item, index) in signList"
                :key="index"
                :disabled="item.disabled"
                :value="index"
              >
                第{{ item.classNo }}节 {{ item.classTimeBeginShow
                }}{{ item.disabled ? '【已在节次，不可选中】' : '' }}
              </Option>
            </Select>
          </div>
        </div>
      </div>
      <div class="btn-block">
        <Button @click="handleClose">取消</Button>
        <Button
          type="primary"
          :loading="sureLoading"
          @click="handleSure"
        >确定</Button>
      </div>
    </Modal>
    <RefundDrawerDetails
      ref="refundDetails"
      @refresh="waitBindSignPage"
    ></RefundDrawerDetails>
  </div>
</template>

<script>
import RemoteSelect from '@c/RemoteSelect';
import common from '@/request/common/index.js';
import operationAdmin from '@/request/operationAdmin/index.js';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import { tableColumnsWidth, key, slot, renderFn } from '@/assets/js/resetTableStyle';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import RefundDrawerDetails from '@pv/orderCenter/assets/components/RefundDrawer/Details.vue'; // 退款详情抽屉
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import { timeToYearStr } from '@/utils/utils';
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'CourseSchedulCenterDivideClassSearchWaitClassStudents',
  components: {
    RemoteSelect,
    CascaderYearTerms,
    RefundDrawerDetails
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      initYear: [],
      formValidate: {
        classData: [],
        areaCode: '',
        schoolIdShow: '',
        schoolId: '',
        studentName: '',
        classroomName: '',
        yearCode: '',
        termCode: ''
      },
      loadingArea: false,
      loadingSchool: false,
      schoolList: [],
      gradeAndClassList: [],
      areacodeList: [],
      tableData: [],
      tableLoading: false,
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      tableColumns: [
        slot('学校', 'schoolName', tableColumnsWidth.type6, { fixed: 'left' }),
        key('学生姓名', 'studentName', tableColumnsWidth.type2, { fixed: 'left' }),
        key('年级班级', 'gradeClassName', 120, { fixed: 'left' }),
        // slot('学生状态', 'isFirst', tableColumnsWidth.type2),
        key('学期', 'termName', tableColumnsWidth.type4),
        key('订单编号', 'payOrderId', tableColumnsWidth.type5),
        key('家长手机号', 'phone', 130),
        slot('课程商品名', 'classroomName', tableColumnsWidth.type6),
        slot('提供方', 'orgName', tableColumnsWidth.type6),
        slot('商品价格', 'classroomFee', tableColumnsWidth.type2),
        key('待入班课时数', 'unBindNum', tableColumnsWidth.type2, {
          align: 'center'
        }),
        slot('操作', 'action', tableColumnsWidth.type3, { fixed: 'right' })
      ], // 表头
      pageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      modalShow: false,
      selectRow: {}, // 选择的信息
      signList: [], // 学生考勤记录
      selectClassValue: -1, // 选中哪个节次
      sureLoading: false,
      selectInClassTime: '',
      firstCanSelectIndex: -1
    };
  },
  computed: { ...mapState(['portOrg', 'userInfo']) },
  created() {
    this.getAreaCodeList();
    if (this.$route.query.yearCode && this.$route.query.termCode) {
      this.initYear[0] = Number(this.$route.query.yearCode);
      this.initYear[1] = this.$route.query.termCode;
    }
    if (this.portOrg == 2) {
      this.formValidate.schoolIdShow = this.userInfo.orgId;
      this.formValidate.schoolId = this.userInfo.orgId;
      this.getGradeAndClass();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('CourseSchedulCenterDivideClassSearchWaitClassStudents');
    next();
  },
  activated() {
    this.waitBindSignPage();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    changeValue(e) {
      console.log(e, '拿到的---');
      if (e >= 0) {
        this.selectInClassTime = this.signList[e].classTimeBegin;
      }
    },
    handleClose() {
      this.modalShow = false;
    },
    async handleSure() {
      if (this.selectClassValue === -1) {
        this.$Message.error('请先选择课程');
        return false;
      }
      if (this.selectClassValue > this.firstCanSelectIndex) {
        this.$Message.error(`该日期入班后的可绑定考勤节次数少于${this.selectRow.unBindNum}，入班失败，请重新选择入班节次。`);
        return false;
      }
      const params = {
        payOrderId: this.selectRow.payOrderId,
        inClassTime: this.selectInClassTime,
        productId: this.selectRow.classroomId,
        inClassroomId: this.selectRow.inClassClassroomId
      };
      console.log(params, '拿到的入参---');
      this.sureLoading = true;
      const res = await courseSchedulCenter.unbindSignInClassApi(params);
      this.sureLoading = false;
      if (res.status === 200) {
        this.$Message.success('入班成功');
        this.modalShow = false;
        this.waitBindSignPage();
      }
    },
    // 点击入班按钮
    async handleToOpenModal(row) {
      this.selectRow = row;
      this.selectClassValue = -1;
      this.signList = [];
      this.modalShow = true;
      await this.getClassroomDetailList();
    },
    handleApplyRefund(row) {
      this.$nextTick(() => {
        this.$refs.refundDetails.openDetailsDrawer({ ...row, insOrderId: row.payOrderId }, 'apply', row.unBindNum);
      });
    },
    // 获取学生在该班级的相关的考勤信息
    async getSignInfo() {
      return new Promise(async(resolve, reject) => {
        const params = {
          payOrderId: this.selectRow.payOrderId,
          studentSts: 1, // 已入班
          searchSignClassroomId: this.selectRow.inClassClassroomId,
          classroomId: this.selectRow.classroomId,
          termCode: this.formValidate.termCode,
          yearCode: this.formValidate.yearCode,
          pageNum: 1,
          pageSize: 10
        };
        const res = await courseSchedulCenter.getEnrollStudents(params);
        if (res.status === 200) {
          const obj = {};
          res.message.list[0].stuSignList.forEach(item => {
            obj[item.classNo] = item;
          });
          resolve(obj);
        } else {
          reject(false);
        }
      });
    },
    async getClassroomDetailList() {
      const params = {
        classroomId: this.selectRow.inClassClassroomId
      };
      console.log(params, '拿到的00');
      const res = await courseSchedulCenter.getSearchClassroomDetail(params);
      if (res.status === 200) {
        const obj = await this.getSignInfo();
        this.signList = res.message.map((item, index) => {
          item.classTimeBeginShow = timeToYearStr(item.classTimeBegin);
          if (obj[item.classNo]) {
            item.disabled = true;
          } else {
            item.disabled = false;
          }
          return { ...item };
        });
        const reversed = res.message.toReversed();
        let selectNum = 0;
        for (let i = 0; i < reversed.length; i++) {
          const item = reversed[i];
          const index = i;
          if (!obj[item.classNo]) {
            selectNum++;
          }
          if (selectNum === this.selectRow.unBindNum) {
            console.log(reversed.length, index, '相同的---42', selectNum, this.selectRow.unBindNum);
            this.firstCanSelectIndex = reversed.length - 1 - index;
            return;
          }
        }
        // reversed.forEach((item, index) => {
        //   if (!obj[item.classNo]) {
        //     selectNum++;
        //   }
        //   if (selectNum === this.selectRow.unBindNum) {
        //     this.firstCanSelectIndex = reversed.length - 1 - index;
        //   }
        // });
      }
    },
    getParameter() {
      let gradeId = ''; let classId = ''; let gradeName = ''; let className = '';
      if (this.formValidate.classData && this.formValidate.classData.length) {
        gradeId = this.formValidate.classData[0];
        classId = this.formValidate.classData[1];
      }
      if (gradeId) {
        gradeName = this.getGradeName(gradeId);
      }
      if (classId) {
        className = this.getClassName(gradeId, classId);
      }
      const { areaCode, schoolId, studentName, classroomName, termCode, yearCode } = this.formValidate;
      return {
        areaCode,
        schoolId: schoolId,
        studentName,
        classroomName,
        gradeName,
        className,
        yearCode,
        termCode,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
    },
    async handleExport() {
      const parameter = this.getParameter();

      if (!parameter.areaCode || !parameter.termCode) {
        return null;
      }
      delete parameter.pageNum;
      delete parameter.pageSize;

      this.$Spin.show();
      const res = await courseSchedulCenter.exportWaitBindSign(parameter);
      this.$Spin.hide();

      downLoadByBlob(res);
    },
    async waitBindSignPage() {
      const parameter = this.getParameter();

      if (!parameter.areaCode || !parameter.termCode) {
        return null;
      }
      this.tableLoading = true;
      const res = await courseSchedulCenter.waitBindSignPageApi(parameter);
      this.tableLoading = false;
      console.log(res);
      if (res.status == 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },
    async getAreaCodeList(query) {
      this.loadingArea = true;
      const params = {};
      query ? params.searchStr = query : '';
      const res = await common.getListAreaCodeApi(params);
      if (res.status === 200) {
        this.areacodeList = res.message.list ? res.message.list : [];
        // !this.formValidate.areaCode && this.areacodeList.length > 0 ? this.formValidate.areaCode = this.areacodeList[0].areaCode : '';
        if (!this.formValidate.areaCode && this.areacodeList.length > 0) {
          const areaCode = localStorage.getItem('areaCodeForLeaveListSearch') ? localStorage.getItem('areaCodeForLeaveListSearch') : this.areacodeList[0].areaCode;
          const areaName = localStorage.getItem('areaNameForLeaveListSearch') ? localStorage.getItem('areaNameForLeaveListSearch') : this.areacodeList[0].areaName;
          const findResult = this.areacodeList.findIndex(item => {
            return item.areaCode === areaCode;
          });
          findResult === -1 ? this.areacodeList.unshift({
            areaCode,
            areaName
          }) : '';
          localStorage.setItem('areaCodeForLeaveListSearch', areaCode);
          localStorage.setItem('areaNameForLeaveListSearch', areaName);
          this.formValidate.areaCode = areaCode;
        }
        this.loadingArea = false;
        this.portOrg == 2 ? '' : this.getSchoolListForAreacode();
        this.handleSearch();
      }
    },
    async onCascaderChange(v) {
      this.yearTermCode = v;
      this.formValidate.yearCode = v.length ? v[0] : '';
      this.formValidate.termCode = v.length ? v[1] : '';
    },
    onCascaderYTInit() {
      this.handleSearch();
    },
    // 通过地区编码获取
    async getSchoolListForAreacode(query) {
      this.loadingSchool = true;
      const params = {
        areaCode: this.formValidate.areaCode,
        pageNum: 1,
        pageSize: 20
      };
      query ? params.searchStr = query : '';
      const res = await operationAdmin.getListSchoolsNewByOfficeAreaCode(params);
      this.loadingSchool = false;
      if (res.status === 200) {
        this.schoolList = res.message.list ? res.message.list : [];
        this.schoolList.unshift({
          schoolId: -1,
          schoolName: '全部',
          orgId: -1,
          name: '全部学校'
        });
      }
    },
    getGradeName(gradeId) {
      const key = this.gradeAndClassList.findIndex(item => {
        return item.value == gradeId;
      });

      return this.gradeAndClassList[key]['label'];
    },
    getClassName(gradeId, classId) {
      const key = this.gradeAndClassList.findIndex(item => {
        return item.value == gradeId;
      });
      const classKey = this.gradeAndClassList[key]['children'].findIndex(item => {
        return item.value == classId;
      });

      return this.gradeAndClassList[key]['children'][classKey]['label'];
    },
    // 当选择了某个学校之后，就去请求校区数据(列表)请求年级班级列表（学生查询）
    handleSchoolSelect(option) {
      if (!option) {
        return;
      }
      this.formValidate.schoolIdShow = option;
      this.formValidate.schoolId = option;
      this.formValidate.classData = [];
      this.gradeAndClassList = [];
      this.$forceUpdate();
      this.getGradeAndClass();
    },
    // 请求年级班级列表
    async getGradeAndClass() {
      const params = {
        schoolId: this.formValidate.schoolIdShow
      };
      const res = await common.getListOrgGradeClass(params);
      if (res.status === 200) {
        this.gradeAndClassList = res.message;
      }
    },
    handleAreaSelect(option) {
      if (!option) {
        return;
      }
      this.formValidate.areaCode = option;
      localStorage.setItem('areaCodeForLeaveListSearch', this.formValidate.areaCode);
      const findResult = this.areacodeList.findIndex(item => {
        return item.areaCode === this.formValidate.areaCode;
      });
      findResult > -1 ? localStorage.setItem('areaNameForLeaveListSearch', this.areacodeList[findResult].areaName) : '';
      this.formValidate.schoolId = null;// 学校id
      this.formValidate.schoolIdShow = -1; // 学校id 默认全部
      this.formValidate.classData = [];
      this.gradeAndClassList = [];
      this.$forceUpdate();
      this.portOrg == 2 ? '' : this.getSchoolListForAreacode();
    },
    loadAllList(val) {
      if (!val) {

      }
    },
    // 选择年级之前，先看有没有选学校
    handleGradeSelect(status) {
      if (
        (status && this.formValidate.schoolIdShow === '') ||
        this.formValidate.schoolIdShow === -1
      ) {
        return this.$Message.error('请先选择学校！');
      }
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.waitBindSignPage();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1;
      this.waitBindSignPage();
    },
    handleSearch() {
      this.pageInfo.pageNum = 1;

      this.waitBindSignPage();
    },
    handleReset() {
      for (const k in this.formValidate) {
        if (['classData'].includes(k)) {
          this.formValidate[k] = [];
        } else {
          this.formValidate[k] = '';
        }
      }
      // this.formValidate.areaCode = this.areacodeList[0]['areaCode'];
      this.formValidate.areaCode = localStorage.getItem('areaCodeForLeaveListSearch') ? localStorage.getItem('areaCodeForLeaveListSearch') : this.areacodeList[0]['areaCode'];
      this.handleAreaSelect(this.formValidate.areaCode);
      const yearTerms = this.$refs.cascaderYearTerms.handleDefault();
      this.onCascaderChange(yearTerms);
      this.waitBindSignPage();
    }
  },
  filters: {
    initIsFirst(str) {
      if (str == 1) {
        return '新报名学生';
      } else if (str == 2) {
        return '离班学生';
      }
      return '';
    },
    initClassroomFee(str) {
      return str ? (Number(str) / 100).toFixed(2) : '';
    }
  }
};
</script>

<style lang="scss" scoped >
.content-430-loading {
  cursor: wait;
}
p {
  line-height: 25px;
}
.form-block {
  .form-line + .form-line {
    margin-top: 30px;
  }
  .form-line {
    display: flex;
    align-items: center;
    .line-left {
      width: 30%;
      text-align: right;
    }
    .line-right {
      font-weight: bold;
      text-align: left;
    }
  }
}
.btn-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  button + button {
    margin-left: 20px;
  }
}
</style>
